<template>
  <div style="position:relative;">
    <div style="height:30px;">
      <div class="panelText pro" @click="twinkle_start(1)" :style="{backgroundColor: noPlateNumber ? '#F5F7FA' : '#fff'}">{{panelArr[0]}}<em  v-if="cursor && keyBoardType === 1">|</em></div>
      <div class="panelText text" @click="twinkle_start(2)" :style="{backgroundColor: noPlateNumber ? '#F5F7FA' : '#fff'}">{{panelArr[1]}}<em  v-if="cursor && keyBoardType === 2">|</em></div>
    </div>
    <div v-if="panelShow" class="vehicle-panel" style="height:290px;">
      <div class="vehicle-panel-row row-btn"><div class="top-button" @click="down">取消</div><div class="top-button finish" @click="vehicleTap('ok')">完成</div></div>
      <!--省份简写键盘-->
      <section v-if="keyBoardType === 1">
        <div class="vehicle-panel-row">
          <div class="vehicle-panel-row-button" v-for="(item, idx) in keyVehicle1" @click="vehicleTap(item)" :key="idx">{{item}}</div>
        </div>
        <div class="vehicle-panel-row">
          <div class="vehicle-panel-row-button" v-for="(item, idx) in keyVehicle2" @click="vehicleTap(item)" :key="idx">{{item}}</div>
        </div>
        <div class="vehicle-panel-row">
          <div class="vehicle-panel-row-button" v-for="(item, idx) in keyVehicle3" @click="vehicleTap(item)" :key="idx">{{item}}</div>
        </div>
        <div class="vehicle-panel-row-last">
          <div class="vehicle-panel-row-button2" @click="changKeyBoard(2)">ABC</div>
          <div class="vehicle-panel-row-button" @click="vehicleTap('临')">临</div>
<!--          <div class="vehicle-panel-row-button vehicle-panel-row-button-last" v-for="(item, idx) in keyVehicle4" @click="vehicleTap(item)" :key="idx">{{item}}</div>-->
          <div class="vehicle-panel-row-button3 vehicle-panel-row-button-img"  @click="vehicleTap('delete')"><!-- data-value="delete"-->
            <img src='https://api.zoeeasy.com/static/upload/2019/06/10/626979686c7377745055.png' class='vehicle-en-button-delete'/>
          </div>
        </div>
      </section>
      <!--英文键盘  -->
      <section v-else>
        <div class="vehicle-panel-row">
          <div class="vehicle-panel-row-button vehicle-panel-row-button-number" v-for="(item, idx) in keyNumber" @click="vehicleTap(item)" :key="idx">{{item}}</div>
        </div>
        <div class="vehicle-panel-row">
          <div class="vehicle-panel-row-button" v-for="(item, idx) in keyEnInput1" @click="vehicleTap(item)" :key="idx">{{item}}</div>
        </div>
        <div class="vehicle-panel-row">
          <div class="vehicle-panel-row-button" v-for="(item, idx) in keyEnInput2" @click="vehicleTap(item)" :key="idx">{{item}}</div>
        </div>
        <div class="vehicle-panel-row">
          <div class="vehicle-panel-row-button" v-for="(item, idx) in keyEnInput3" @click="vehicleTap(item)" :key="idx">{{item}}</div>
        </div>
        <div class="vehicle-panel-row-last engLast">
          <div class='vehicle-panel-row-button2' @click="changKeyBoard(1)">省份</div>
          <div class="mod04">
            <div class="mod04-row">
              <div class="vehicle-panel-row-button vehicle-panel-row-button" v-for="(item, idx) in keyVehicle4" @click="vehicleTap(item)" :key="idx">{{item}}</div>
            </div>
          </div>
          <div class="vehicle-panel-row-button3 vehicle-panel-row-button-img" @click="vehicleTap('delete')"><!-- data-value="delete"-->
            <img src='https://api.zoeeasy.com/static/upload/2019/06/10/626979686c7377745055.png' class='vehicle-en-button-delete'/>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    noPlateNumber: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formInline: {
        user: '',
        region: ''
      },
      keyVehicle1: '京津沪冀豫云陕辽浙赣',
      keyVehicle2: '黑湘皖鲁新苏鄂桂甘晋',
      keyVehicle3: '蒙吉闽贵粤川青琼宁渝',
      keyNumber: '1234567890',
      keyEnInput1: 'QWERTYUIOP',
      keyEnInput2: 'ASDFGHJKLZ',
      keyEnInput3: 'XCVBNM藏学警军',
      keyVehicle4: '港澳领',
      cursor: false,
      time: null,
      panelShow: false,
      panelMore: false,
      keyBoardType: 1,
      panelArr: ['', ''],
    };
  },
  watch: {
    dialogVisible(v) {
      if(!v){
        this.panelArr = ['', ''];
      }
    },
  },
  methods: {
    changKeyBoard(e){
      this.keyBoardType = e
    },
    twinkle_start(n){
      this.keyBoardType = n;
      // this.panelArr[n - 1] = '';
      if (this.panelShow) {
        this.twinkle_stop();
      } else if(!this.noPlateNumber) {
        this.panelShow = true;
        this.twinkle_cursor();
      }
    },
    twinkle_stop() {
      this.cursor = true;
    },
    twinkle_cursor() {
      this.cursor = !this.cursor;
      if (this.panelShow) {
        let time = setTimeout(()=> {
          this.twinkle_cursor();
        }, 500);
        this.time = time
      } else {
        clearTimeout(this.time);
      }
    },
    vehicleTap(val) {
      switch (val) {
        case 'delete':
          this.handleDelete();
          break;
        case 'ok':
          this.handleOk();
          break;
        default:
          this.handleChange(val);
      }
    },
    handleOk() {
      // let Reg = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
      // let panelText = this.panelArr.join('');
      // if (Reg.test(panelText)) {
      // this.panelShow = false;
      // this.$emit('ok', this.panelArr.join(''));
      // } else {
      //   this.$message({
      //     message: '车牌格式输入有误',
      //     type: 'warning'
      //   });
      // }
      console.log(this.panelArr)
      this.panelShow = false;
      this.$emit('ok', this.panelArr.join(''));
    },
    handleDelete() {
      let str = this.panelArr[this.keyBoardType - 1];
      str = str.slice(0, str.length - 1);
      this.panelArr[this.keyBoardType - 1] = str;
    },
    handleChange(e) {
      if (this.keyBoardType === 1) {
        this.panelArr[0] = e;
        this.keyBoardType = 2;
      } else if (this.panelArr[1].length <= 7){
        this.panelArr[1] += e
      }
      // this.$emit('ok', this.panelArr.join(''));
    },
    down(){
      this.panelShow = false;
      this.keyBoardType = 1;
      this.panelArr = ['', ''];
      this.twinkle_stop();
      this.$emit('ok', this.panelArr.join(''));
    }
  }
};
</script>

<style  scoped>
  .panelText{
    display: inline-block;
    vertical-align: bottom;
    width: 40px;
    margin: 2px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .panelText.text{
    width: 178px;
  }
  .vehicle-panel {
    width: 400px;
   position: absolute;
    top: 43px;
    left: calc(50% - 200px);
    display:flex;
    flex-direction:column;
    justify-content:center;
    z-index: 2100;
    background: #fff;
    padding: 0 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 18px;
    font-family:PingFang-SC-Bold;
  }
  .vehicle-panel-row {
    padding-top: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .vehicle-panel-row-last{
    padding: 3px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mod04{
    width:82%;
    display: flex;
    flex-direction: column ;
  }
  .mod04-row{
    display: flex;
    flex-direction: row;
  }
  .vehicle-panel-row-button {
    background-color: #fff;
    margin: 2px;
    padding: 2px;
    width: 32px;
    height: 34px;
    text-align: center;
    line-height: 29px;
    border:1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
  }
  .vehicle-panel-row-button2{
    background-color: #ccc;
    margin: 2px;
    padding: 2px;
    width: 50px;
    height: 30px;
    text-align: center;
    line-height: 29px;
    border:1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
  }
  .vehicle-panel-row-button3{
    margin: 2px;
    padding: 2px;
    width: 50px;
    height: 34px;
    text-align: center;
    line-height: 29px;
    border:1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
  }
  .vehicle-panel-row-button-number {
    background-color: #eee;
  }
  .vehicle-panel-row-button-last {
    width: 32px;
    height: 32px;
    line-height: 34px;
  }
  .vehicle-hover {
    background-color: #ccc;
  }
  .vehicle-panel-row-button-img {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0F4BA1;
  }
  .vehicle-en-button-delete {
    width: 11px;
    height: 11px;
  }
  .vehicle-panel-ok {
    background-color: #0F4BA1;
    color: #fff;
    width: 60px;
    height: 34px;
    display:flex;
    align-items:center;
    justify-content:center;
  }
  .top-button{
    width: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    cursor: pointer;
  }
  .row-btn{
    background-color: #f8f8f8
  }
  .finish{
    color: #3296FA;
  }
  .mod04{
    display: flex;
    justify-content: center;
    align-items: center
  }

</style>
